<!--
 * @Author: your name
 * @Date: 2020-05-16 08:47:58
 * @LastEditTime: 2020-05-17 14:57:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Research.vue
 -->
<template>
  <div class="Research" :style="`background: url('${require('../assets/research/first.png')}') no-repeat; background-size: 100% 100%;`">
    <div class="body">
      <p class="participate" @click="downPage()">
          <span class="wenJuan">参与问卷</span>
      </p>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  name: 'Research',
   data() {
    return {
        openid: '', 
    };
  },
  methods:  {
      downPage() {
          this.$router.push({ name: "ResearchPart2"})
      }
  },
  mounted: function() {
    this.openid = Cookies.get('openid')
    // 跳转到首页
    if(!this.openid){
        this.$router.push({ name: "Research"})
    }
  },
}
</script>

<style lang="less" scoped>
.Research {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    .body {
       .participate{
            width: 90%;
            height: 45px;
            background: #FFFFFF;
            border-radius: 45px;
            border-radius: 45px;
            text-align: center;
            position: absolute;
            bottom: 10%;
            margin-left: 5%;
            line-height: 36px;
            .wenJuan{
                font-family: PingFangSC-Regular;
                font-size: 20px;
                color: #012C9C;
                letter-spacing: 0;
            }
       }
       
     }
}
</style>


// WEBPACK FOOTER //
// src/components/Research.vue